<kb-control-container
  [showError]="showError"
  [controlId]="controlId"
  #controlContainerElement
>
  <label class="input-container"> <!--This needs to be a label to support focus on icon click -->
    <input
      [id]="controlId"
      type="range"
      kbRangeValueAccessor
      [attr.aria-describedby]="controlContainerElement ? controlContainerElement.hintElement?.id : null"
      [attr.required]="required ? '' : null"
      [tabindex]="tabindex"
      [step]="step"
      [min]="min"
      [max]="max"
      [style.background]="getProgressBackground()"
      #input
    >
  </label>
  <kb-label><ng-content></ng-content></kb-label>
  <ng-content select="kb-hint" ngProjectAs="kb-hint"></ng-content>
  <ng-content select="kb-error" ngProjectAs="kb-error"></ng-content>
</kb-control-container>
